import CirclePlusFilled from '../../src/legacy/CirclePlusFilled';
export default CirclePlusFilled;
